export default "__VITE_ASSET__CkoK8vqe__"